let Ip = ''
let OutIp = ''
let MediumIp = ''
if (process.env.NODE_ENV === 'development') {
  //Ip = 'https://wapp.nhlsf.top'
  //Ip = 'http://47.95.203.43:80'
  //OutIp = '47.95.203.43:8001'
  Ip = 'http://101.42.177.229:9900'
  OutIp = '101.42.177.229:8001'
  MediumIp = Ip
  // } else if (process.env.NODE_ENV === 'production') {
} else {
  const oProtocol = window.location.protocol
  const oIp = window.location.hostname

  Ip = oProtocol + '//' + oIp
  OutIp = oIp + ':8001'
  MediumIp = 'http://' + oIp
}
const IP = {
  Ip: Ip,
  OutIp: OutIp,
  MediumIp: MediumIp
}

export default IP
